import * as React from "react";
import S from "./Footer.styled";
import useFooterData from "./useFooterData";
import { toGatsbyImage } from "@/src/helpers";
import InstaIcon from "@/assets/instagram.svg";
import FacebookIcon from "@/assets/facebook.svg";
import VimeoIcon from "@/assets/vimeo.svg";

const Footer: React.FC = () => {
  const {
    logo,
    contactColumn: { title, address, email, imagePhone, phone },
    infoContent: { infoText },
    legal: { links },
    linksColumn,
    socialMediaColumn,
  } = useFooterData();

  const imageData = toGatsbyImage(logo);

  const renderLinks = linksColumn.footerLinks?.map(({ link }, index) => {
    return (
      <S.LinkItem key={index}>
        <S.Link to={link.url} target={link.target}>
          {link.title}
        </S.Link>
      </S.LinkItem>
    );
  });

  const renderSomeLinks = socialMediaColumn.socialMediaLinks?.map(
    ({ link, icon }, index) => {
      return (
        <S.SoMeLink key={index} href={link.url}>
          {icon === "facebook" && (
            <FacebookIcon aria-label="Länk till Facebook" />
          )}
          {icon === "instagram" && (
            <InstaIcon aria-label="Länk till Instagram" />
          )}
          {icon === "vimeo" && <VimeoIcon aria-label="Länk till Vimeo" />}
        </S.SoMeLink>
      );
    }
  );

  return (
    <S.Footer>
      <S.LogoWrapper className="div1">
        {imageData && <S.Logo image={imageData} alt={logo.altText || ""} />}
      </S.LogoWrapper>
      <S.ColumnsWrapper className="div2">
        <S.Column>
          {linksColumn.title && (
            <S.ColumnTitle>{linksColumn.title}</S.ColumnTitle>
          )}
          <S.LinksWrapper>{renderLinks}</S.LinksWrapper>
        </S.Column>
        <S.Column>
          {title && <S.ColumnTitle>{title}</S.ColumnTitle>}
          <S.LinksWrapper>
            {imagePhone && (
              <S.LinkItem>
                <S.ExternalLink href={`mailto:${imagePhone}`}>
                  Bildtelefon: {imagePhone}
                </S.ExternalLink>
              </S.LinkItem>
            )}
            {phone && (
              <S.LinkItem>
                <S.ExternalLink href={`tel:${phone}`}>
                  Telefon: {phone}
                </S.ExternalLink>
              </S.LinkItem>
            )}
            {email && (
              <S.LinkItem>
                <S.ExternalLink href={`mailto:${email}`}>
                  E-post: {email}
                </S.ExternalLink>
              </S.LinkItem>
            )}
            {address && (
              <S.LinkItem>
                <S.InfoText>{address}</S.InfoText>
              </S.LinkItem>
            )}
          </S.LinksWrapper>
        </S.Column>
        <S.Column>
          {socialMediaColumn.title && (
            <S.ColumnTitle>{socialMediaColumn.title}</S.ColumnTitle>
          )}
          <S.SoMeWrapper>{renderSomeLinks}</S.SoMeWrapper>
        </S.Column>
      </S.ColumnsWrapper>
      <S.InfoWrapper className="div3">
        <div>
          {infoText?.map(({ text }, index) => (
            <S.InfoText key={index}>{text}</S.InfoText>
          ))}
        </div>
        <div>
          {links?.map(({ link }, index) => (
            <S.Link to={link.url} key={index} target={link.target}>
              {link.title}
            </S.Link>
          ))}
        </div>
      </S.InfoWrapper>
    </S.Footer>
  );
};

export default Footer;
